"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOT = exports.NUMPAD_DOT = exports.NUMPAD_9 = exports.NUMPAD_8 = exports.NUMPAD_7 = exports.NUMPAD_6 = exports.NUMPAD_5 = exports.NUMPAD_4 = exports.NUMPAD_3 = exports.NUMPAD_2 = exports.NUMPAD_1 = exports.NUMPAD_0 = exports.NUM_9 = exports.NUM_8 = exports.NUM_7 = exports.NUM_6 = exports.NUM_5 = exports.NUM_4 = exports.NUM_3 = exports.NUM_2 = exports.NUM_1 = exports.NUM_0 = exports.DELETE = exports.insert = exports.downArrow = exports.rightArrow = exports.upArrow = exports.leftArrow = exports.home = exports.end = exports.pageDown = exports.pageUp = exports.space = exports.esc = exports.alt = exports.ctrl = exports.shift = exports.enter = exports.tab = exports.backspace = void 0;

/**
 * @classdesc
 * The most common used keyCodes.
 *
 * @class skybase-core.constants.keyCodes
 * @static
 *
 * @type {Object}
 */

/**
 * Backspace keycode - 8
 * @name skybase-core.constants.keyCodes#backspace
 * @type {Number}
 */
var backspace = 8;
/**
 * Tab keycode - 9
 * @name skybase-core.constants.keyCodes#tab
 * @type {Number}
 */

exports.backspace = backspace;
var tab = 9;
/**
 * Enter keycode - 13
 * @name skybase-core.constants.keyCodes#enter
 * @type {Number}
 */

exports.tab = tab;
var enter = 13;
/**
 * Shift keycode- 16
 * @name skybase-core.constants.keyCodes#shift
 * @type {Number}
 */

exports.enter = enter;
var shift = 16;
/**
 * Ctrl keycode - 17
 * @name skybase-core.constants.keyCodes#ctrl
 * @type {Number}
 */

exports.shift = shift;
var ctrl = 17;
/**
 * Alt keycode - 18
 * @name skybase-core.constants.keyCodes#alt
 * @type {Number}
 */

exports.ctrl = ctrl;
var alt = 18;
/**
 * Esc keycode - 27
 * @name skybase-core.constants.keyCodes#esc
 * @type {Number}
 */

exports.alt = alt;
var esc = 27;
/**
 * Space keycode - 32
 * @name skybase-core.constants.keyCodes#space
 * @type {Number}
 */

exports.esc = esc;
var space = 32;
/**
 * PageUp keycode - 33
 * @name skybase-core.constants.keyCodes#pageUp
 * @type {Number}
 */

exports.space = space;
var pageUp = 33;
/**
 * PageDown keycode - 34
 * @name skybase-core.constants.keyCodes#pageDown
 * @type {Number}
 */

exports.pageUp = pageUp;
var pageDown = 34;
/**
 * End keycode - 35
 * @name skybase-core.constants.keyCodes#end
 * @type {Number}
 */

exports.pageDown = pageDown;
var end = 35;
/**
 * Home keycode - 36
 * @name skybase-core.constants.keyCodes#home
 * @type {Number}
 */

exports.end = end;
var home = 36;
/**
 * LeftArrow keycode - 37
 * @name skybase-core.constants.keyCodes#leftArrow
 * @type {Number}
 */

exports.home = home;
var leftArrow = 37;
/**
 * UpArrow keycode - 38
 * @name skybase-core.constants.keyCodes#upArrow
 * @type {Number}
 */

exports.leftArrow = leftArrow;
var upArrow = 38;
/**
 * RightArrow keycode - 39
 * @name skybase-core.constants.keyCodes#rightArrow
 * @type {Number}
 */

exports.upArrow = upArrow;
var rightArrow = 39;
/**
 * DownArrow keycode - 33
 * @name skybase-core.constants.keyCodes#downArrow
 * @type {Number}
 */

exports.rightArrow = rightArrow;
var downArrow = 40;
/**
 * Insert keycode - 45
 * @name skybase-core.constants.keyCodes#insert
 * @type {Number}
 */

exports.downArrow = downArrow;
var insert = 45;
/**
 * Delete keycode - 46
 * @name skybase-core.constants.keyCodes#delete
 * @type {Number}
 */

exports.insert = insert;
var DELETE = 46;
/**
 * Key '0' - keycode - 48
 * @name skybase-core.constants.keyCodes#0
 * @type {Number}
 */

exports.DELETE = DELETE;
var NUM_0 = 48;
/**
 * Key '1' - keycode - 49
 * @name skybase-core.constants.keyCodes#1
 * @type {Number}
 */

exports.NUM_0 = NUM_0;
var NUM_1 = 49;
/**
 * Key '2' - keycode - 50
 * @name skybase-core.constants.keyCodes#2
 * @type {Number}
 */

exports.NUM_1 = NUM_1;
var NUM_2 = 50;
/**
 * Key '3' - keycode - 51
 * @name skybase-core.constants.keyCodes#3
 * @type {Number}
 */

exports.NUM_2 = NUM_2;
var NUM_3 = 51;
/**
 * Key '4' - keycode - 52
 * @name skybase-core.constants.keyCodes#4
 * @type {Number}
 */

exports.NUM_3 = NUM_3;
var NUM_4 = 52;
/**
 * Key '5' - keycode - 53
 * @name skybase-core.constants.keyCodes#5
 * @type {Number}
 */

exports.NUM_4 = NUM_4;
var NUM_5 = 53;
/**
 * Key '6' - keycode - 54
 * @name skybase-core.constants.keyCodes#6
 * @type {Number}
 */

exports.NUM_5 = NUM_5;
var NUM_6 = 54;
/**
 * Key '7' - keycode - 55
 * @name skybase-core.constants.keyCodes#7
 * @type {Number}
 */

exports.NUM_6 = NUM_6;
var NUM_7 = 55;
/**
 * Key '8' - keycode - 56
 * @name skybase-core.constants.keyCodes#8
 * @type {Number}
 */

exports.NUM_7 = NUM_7;
var NUM_8 = 56;
/**
 * Key '9' - keycode - 57
 * @name skybase-core.constants.keyCodes#9
 * @type {Number}
 */

exports.NUM_8 = NUM_8;
var NUM_9 = 57;
/**
 * Numpad key '0' - keycode - 96
 * @name skybase-core.constants.keyCodes#numpad0
 * @type {Number}
 */

exports.NUM_9 = NUM_9;
var NUMPAD_0 = 96;
/**
 * Numpad key '1' - keycode - 97
 * @name skybase-core.constants.keyCodes#numpad1
 * @type {Number}
 */

exports.NUMPAD_0 = NUMPAD_0;
var NUMPAD_1 = 97;
/**
 * Numpad key '2' - keycode - 98
 * @name skybase-core.constants.keyCodes#numpad2
 * @type {Number}
 */

exports.NUMPAD_1 = NUMPAD_1;
var NUMPAD_2 = 98;
/**
 * Numpad key '3' - keycode - 99
 * @name skybase-core.constants.keyCodes#numpad3
 * @type {Number}
 */

exports.NUMPAD_2 = NUMPAD_2;
var NUMPAD_3 = 99;
/**
 * Numpad key '4' - keycode - 100
 * @name skybase-core.constants.keyCodes#numpad4
 * @type {Number}
 */

exports.NUMPAD_3 = NUMPAD_3;
var NUMPAD_4 = 100;
/**
 * Numpad key '5' - keycode - 101
 * @name skybase-core.constants.keyCodes#numpad5
 * @type {Number}
 */

exports.NUMPAD_4 = NUMPAD_4;
var NUMPAD_5 = 101;
/**
 * Numpad key '6' - keycode - 102
 * @name skybase-core.constants.keyCodes#numpad6
 * @type {Number}
 */

exports.NUMPAD_5 = NUMPAD_5;
var NUMPAD_6 = 102;
/**
 * Numpad key '7' - keycode - 103
 * @name skybase-core.constants.keyCodes#numpad7
 * @type {Number}
 */

exports.NUMPAD_6 = NUMPAD_6;
var NUMPAD_7 = 103;
/**
 * Numpad key '8' - keycode - 104
 * @name skybase-core.constants.keyCodes#numpad8
 * @type {Number}
 */

exports.NUMPAD_7 = NUMPAD_7;
var NUMPAD_8 = 104;
/**
 * Numpad key '9' - keycode - 105
 * @name skybase-core.constants.keyCodes#numpad9
 * @type {Number}
 */

exports.NUMPAD_8 = NUMPAD_8;
var NUMPAD_9 = 105;
/**
 * Number Pad Dot - keycode - 110
 * @name skybase-core.constants.keyCodes#numpadDot
 * @type {Number}
 */

exports.NUMPAD_9 = NUMPAD_9;
var NUMPAD_DOT = 110;
/**
 * Period or Dot - keycode - 190
 * * @name skybase-core.constants.keyCodes#dot
 * @type {Number}
 */

exports.NUMPAD_DOT = NUMPAD_DOT;
var DOT = 190;
exports.DOT = DOT;
//# sourceMappingURL=keyCodes.js.map